import type { FlyUIEnvironment } from "@wayflyer/flyui";

export const isStorybook = () => typeof window !== "undefined" && (window as any).DOCS_OPTIONS;

const PRODUCTION_HOST = "app.wayflyer.com";

/**
 * The `environment` prop for `FlyUIProvider`: a critical "Production" tag shown to staff
 * on the production host, and nothing anywhere else. Pass `isStaff` from the app's user
 * context; the staff app can pass `true`, as every user there is staff.
 */
export const getFlyUIEnvironment = ({ isStaff }: { isStaff: boolean }): FlyUIEnvironment | undefined =>
  isStaff && typeof window !== "undefined" && window.location.host === PRODUCTION_HOST
    ? { label: "Production", status: "critical" }
    : undefined;
